(function () {
  var cleanupKey = '__valyrxPrjTimesCleanup';

  function getScroller() {
    var pageWrapper = document.querySelector('.page-wrapper');

    if (pageWrapper && pageWrapper.scrollHeight > pageWrapper.clientHeight + 1) {
      return pageWrapper;
    }

    return window;
  }

  function revealStatic(root, gsap) {
    var title = root.querySelector('[data-prj-times-title]');
    var frame = root.querySelector('[data-prj-times-frame]');
    var copy = root.querySelector('.valyrx-prj-times__copy');
    var ambient = root.querySelector('[data-prj-times-ambient]');
    var rgbLayers = root.querySelectorAll(
      '[data-prj-times-layer="cyan"], [data-prj-times-layer="magenta"]'
    );
    var scan = root.querySelector('[data-prj-times-scan]');

    if (!gsap) {
      return;
    }

    gsap.set([title, frame, copy], { clearProps: 'all' });
    if (ambient) {
      gsap.set(ambient, { clearProps: 'transform,opacity' });
    }
    gsap.set(rgbLayers, { autoAlpha: 0, x: 0 });
    gsap.set(scan, { autoAlpha: 0, xPercent: 0, scaleX: 0 });
  }

  function destroy(root) {
    if (typeof root[cleanupKey] === 'function') {
      root[cleanupKey]();
    }

    root[cleanupKey] = null;
  }

  function init(root) {
    if (!root || root[cleanupKey]) {
      return;
    }

    var gsap = window.gsap;
    var ScrollTrigger = window.ScrollTrigger;

    if (!gsap || !ScrollTrigger) {
      revealStatic(root, gsap);
      return;
    }

    var title = root.querySelector('[data-prj-times-title]');
    var frame = root.querySelector('[data-prj-times-frame]');
    var statement = root.querySelector('.valyrx-prj-times__statement');
    var copy = root.querySelector('.valyrx-prj-times__copy');
    var ambient = root.querySelector('[data-prj-times-ambient]');
    var scan = root.querySelector('[data-prj-times-scan]');
    var cyan = root.querySelector('[data-prj-times-layer="cyan"]');
    var magenta = root.querySelector('[data-prj-times-layer="magenta"]');

    if (!title || !frame || !scan || !cyan || !magenta) {
      return;
    }

    var media = gsap.matchMedia();
    var scrollRoot = getScroller();

    media.add(
      {
        isDesktop: '(min-width: 750px)',
        isMobile: '(max-width: 749px)',
        reduceMotion: '(prefers-reduced-motion: reduce)',
      },
      function (context) {
        var conditions = context.conditions;

        if (conditions.reduceMotion) {
          revealStatic(root, gsap);
          return;
        }

        gsap.set(frame, { clipPath: 'inset(0 100% 0 0)' });
        gsap.set(title, { autoAlpha: 0, y: conditions.isDesktop ? 36 : 20 });
        gsap.set([statement, copy], { autoAlpha: 0, y: conditions.isDesktop ? 24 : 14 });
        gsap.set([cyan, magenta], { autoAlpha: 0, x: 0 });
        gsap.set(scan, { autoAlpha: 0, xPercent: 0, scaleX: 0 });

        var intro = gsap.timeline({
          defaults: { ease: 'power3.out' },
          scrollTrigger: {
            trigger: root,
            scroller: scrollRoot,
            start: conditions.isDesktop ? 'top 78%' : 'top 88%',
            toggleActions: 'play none none reverse',
          },
        });

        intro
          .addLabel('open')
          .to(frame, { clipPath: 'inset(0 0% 0 0)', duration: 0.92 }, 'open')
          .to(title, { autoAlpha: 1, y: 0, duration: 0.7 }, 'open+=0.12')
          .to(statement, { autoAlpha: 1, y: 0, duration: 0.72 }, 'open+=0.2')
          .to(scan, { autoAlpha: 1, scaleX: 1, duration: 0.2, ease: 'power1.out' }, 'open+=0.35')
          .to(scan, { xPercent: 560, duration: 0.64, ease: 'power2.inOut' }, 'open+=0.42')
          .to(
            cyan,
            { autoAlpha: 0.24, x: conditions.isDesktop ? -7 : -3, duration: 0.08, ease: 'none' },
            'open+=0.5'
          )
          .to(
            magenta,
            { autoAlpha: 0.2, x: conditions.isDesktop ? 7 : 3, duration: 0.08, ease: 'none' },
            '<'
          )
          .to([cyan, magenta], { autoAlpha: 0, x: 0, duration: 0.22, ease: 'power2.out' }, 'open+=0.68')
          .set(scan, { autoAlpha: 0 })
          .to(copy, { autoAlpha: 1, y: 0, duration: 0.76 }, 'open+=0.56');

        if (ambient) {
          gsap.fromTo(
            ambient,
            { scale: 1.08, autoAlpha: 0.08 },
            {
              scale: conditions.isDesktop ? 1.16 : 1.12,
              autoAlpha: 0.18,
              ease: 'none',
              scrollTrigger: {
                trigger: root,
                scroller: scrollRoot,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                invalidateOnRefresh: true,
              },
            }
          );
        }

        if (conditions.isDesktop) {
          gsap.fromTo(
            frame,
            { yPercent: 4 },
            {
              yPercent: -4,
              ease: 'none',
              scrollTrigger: {
                trigger: root,
                scroller: scrollRoot,
                start: 'top bottom',
                end: 'bottom top',
                scrub: true,
                invalidateOnRefresh: true,
              },
            }
          );
        }
      }
    );

    function refresh() {
      ScrollTrigger.refresh();
    }

    var heroImage = root.querySelector('[data-prj-times-layer="base"]');

    if (heroImage && !heroImage.complete) {
      heroImage.addEventListener('load', refresh, { once: true });
    }

    root[cleanupKey] = function () {
      if (heroImage) {
        heroImage.removeEventListener('load', refresh);
      }

      media.revert();
    };

    refresh();
  }

  function initAll(scope) {
    var container = scope || document;

    if (container.matches && container.matches('[data-valyrx-prj-times]')) {
      init(container);
    }

    container.querySelectorAll('[data-valyrx-prj-times]').forEach(init);
  }

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
      return;
    }

    callback();
  }

  ready(function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var root = event.target.matches('[data-valyrx-prj-times]')
      ? event.target
      : event.target.querySelector('[data-valyrx-prj-times]');

    if (root) {
      destroy(root);
    }
  });

  document.addEventListener('shopify:section:reorder', function (event) {
    initAll(event.target);
  });
})();
